module.exports = __webpack_public_path__ + "static/media/221-tuvalu.562936f5.svg";